import type { ReactNode } from 'react'
import { HTMLAttributes } from 'react'
import { Link, useLocation } from 'react-router'

import { AddIcon } from '@pleio/icons/add'

import Button from 'js/components/Button'
import Document from 'js/components/Document'
import { Container } from 'js/components/Grid'
import { H1 } from 'js/components/Heading'
import Section from 'js/components/Section/Section'

import styles from './PageHeader.module.css'

/*
    Props createLink and createLabel are only allowed when canCreate is true
*/

interface BaseProps extends HTMLAttributes<HTMLDivElement> {
    title: string
    children?: ReactNode
}

interface CanCreateTrueProps extends BaseProps {
    canCreate: true
    createLink: string
    createLabel: string
}

interface CanCreateFalseProps extends BaseProps {
    canCreate?: false
    createLink?: never
    createLabel?: never
}

export type Props = CanCreateTrueProps | CanCreateFalseProps

const PageHeader = ({
    title,
    canCreate,
    createLink,
    createLabel,
    children,
    ...rest
}: Props) => {
    const location = useLocation()
    return (
        <>
            <Document title={title} />
            <Section backgroundColor="white" divider {...rest}>
                <Container>
                    <div className={styles.topWrapper}>
                        <H1>{title}</H1>
                        {canCreate && (
                            <Button
                                as={Link}
                                to={createLink}
                                state={{ prevPathname: location.pathname }}
                                size="large"
                                variant="primary"
                                className={styles.createButton}
                                data-testid="button-create"
                            >
                                <AddIcon style={{ marginRight: '6px' }} />
                                {createLabel}
                            </Button>
                        )}
                    </div>
                    {children}
                </Container>
            </Section>
        </>
    )
}

export default PageHeader
